import React, { Component} from 'react';
import * as scriptUtils from './utils/scriptUtils';
import { IoMdClose } from 'react-icons/io';
import './ChatUserInformationModal.css';


class ChatUserNFTs extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="grid grid-cols-3">
        {
          this.props.userOwnedNFTs.map((userOwnedNFT, ind) => {
            return (
              <div className="mt-2.5 flex justify-center" key={ind}>
                <img
                  onClick={() => this.props.selectNFTPFP(userOwnedNFT)}
                  className={
                    this.props.pfp === userOwnedNFT
                      ?
                    "border-teal-500 border-2 w-12 h-12 bg-gray-200 cursor-pointer"
                      :
                    "w-12 h-12 bg-gray-200 cursor-pointer"
                  }
                  src={userOwnedNFT}
                />
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default ChatUserNFTs;
